"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_FLOW_TYPE = exports.CATALOG_ITEM_SOURCE = exports.ITEM_QUANTITY = void 0;
//Constants for now, may need to return to these if supporting multiple items
exports.ITEM_QUANTITY = 1;
exports.CATALOG_ITEM_SOURCE = "NETSUITE";
exports.CHECKOUT_FLOW_TYPE = "SINGLE_ITEM_PURCHASE";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/checkoutUrlBuilderApi/constants.js
// module id = 3410
// module chunks = 11